/* eslint-disable */
const mapUtil = function () {
    var init = function (container) {
        var map = new AMap.Map(container, {
            resizeEnable: true,
            zoom: 13
        });
        map.plugin(["AMap.Scale"], function () { //加载比例尺插件      
            let scale = new AMap.Scale();
            map.addControl(scale);
            scale.show();
        });
        map.plugin('AMap.Geolocation', function () {
            let geolocation = new AMap.Geolocation({
                enableHighAccuracy: true, //是否使用高精度定位，默认:true
                timeout: 2000, //超过10秒后停止定位，默认：5s
                buttonPosition: 'RB', //定位按钮的停靠位置
                buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                panToLocation: false, //定位成功后将定位到的位置作为地图中心点，默认：true
                zoomToAccuracy: false //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false

            });
            map.addControl(geolocation);
            geolocation.getCurrentPosition(function (status, result) {
                if (status == 'complete') {
                    onComplete(result)
                } else {
                    onError(result)
                }
            });
        });
        //解析定位结果
        function onComplete(data) {
            let points = [{
                Type: "me",
                Gis: data.position.toString(),
                Name: '当前位置'
            }];
            drawpoint(map, points, function (target) {
                console.log(target);
            });
            setTimeout(function () {
                map.setFitView();
            }, 20)
        }
        //解析定位错误信息
        function onError(data) {
            console.log('失败原因排查信息:' + data.message);
        }
        return map;
    }
    //线路规划
    var driving = function (map, startLngLat, endLngLat, callback) {
        map.plugin("AMap.Driving", function () {
            var driving = new AMap.Driving({
                policy: 0, //驾车路线规划策略，0是速度优先的策略
            });
            driving.search(startLngLat, endLngLat, function (status, result) {
                //status：complete 表示查询成功，no_data 为查询无结果，error 代表查询错误
                //查询成功时，result 即为对应的驾车导航信息
                if (status == "complete") {
                    callback(null, result);
                } else {
                    callback(new Error('路线规划时间计算失败: ' + status), null);
                }

            });
        });

    }

    var convertFrom = function (gps, type, map, VehicleNo) {

        AMap.convertFrom(gps, type, function (status, result) {
            if (result.info === 'ok') {
                if (window.markerList != null) {
                    window.markerList.forEach(i => {
                        map.remove(i)
                    })
                }
                window.markerList = []
                //alert(result.locations)
                let points = [{
                    Type: "bus",
                    Gis: result.locations.toString(),
                    Name: VehicleNo
                }];
                let option = {
                    lnglat: points[0].Gis,
                    type: points[0].Type
                }
                let marker = createmark(map, option);
                marker.setLabel({
                    content: VehicleNo,
                    offset: {
                        x: VehicleNo.length * -5 + 8,
                        y: -26
                    }
                });
                window.markerList.push(marker)
                setTimeout(function () {
                    map.setFitView();
                }, 20)
                // drawpoint(map, points, function (target) {
                //     console.log(target);
                // });
            }
        });
    }

    var newpoint = function (LngLat) {
        return new AMap.LngLat(parseFloat(LngLat.split(',')[0]), parseFloat(LngLat.split(',')[1]));
    }

    var createmark = function (map, pointinfo) {

        var type = pointinfo.type;
        var lnglat = newpoint(pointinfo.lnglat);
        var option = { //middle_start
            image: "data:image/png;base64,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",
            size: new AMap.Size(12, 12),
            imageSize: new AMap.Size(75, 50)
        };
        var x = -6,
            y = -6;
        if (type == "start") {
            option.size = new AMap.Size(28, 38);
            option.imageOffset = new AMap.Pixel(0, 0);
            x = -14;
            y = -34;
        } else if (type == "end") {
            option.size = new AMap.Size(28, 38);
            option.imageOffset = new AMap.Pixel(-28, 0);
            x = -14;
            y = -34;
        } else if (type == "middle_start") {
            option.imageOffset = new AMap.Pixel(-12, -38);
        } else if (type == "middle_end") {
            option.imageOffset = new AMap.Pixel(-36, -38);
            //2019年8月13日 16:44:11 谢铭垚 取消 我的位置 起 图标的显示
        } else if (type == "start_station") {
            option.image = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAfCAYAAAAFkva3AAADVUlEQVR42qWUa0zNcRzG/2bMS/PG5gVzSyJ3ueeSg8LG2Bhzm0szRkyG0VG5RKhE7nNZK3OZUhgKbeQ2tNFm5dqy3A66Hef6f3yfX/abHEfF2T773p7n+Z/z4n8MAD5EJNa2E6KFW8I7wfmzFnDP+5989UN21rQQ4gX7xBQXJqUBkw8KR1RVM/e8U0f9H8PCd1S1FvIjkh2YdFiMR/zDO3WivyG0qRc2IaGyuZAXvteBCBGT2aeA9dns/UO9+AqFljps/Pavmyck2RFxGJqtV4Ccorp+1kk1a9ZlQevoo1+FjdtqayvYww94EX4IWJpZF3L3BVD6nr3eabinltBHP3MMy5ZPayy7azDukKmYecJE/GXg9AMGqp77X2FYvZl+yYk2wuI+3LCkOmE5aCoiM4D4S0CmhBVKGPsZx01cLIKmtALUauhnjjEmtuJD2H43wuTrkrhcE9lPoLDV1PWLM0yUfwFvirxiUKuhX3LeG6Ot5d7RaR78yvViE9OPeVBSAb3TvR+YY4zcVFY9ar8Lo9LcimnH3PwWqrc7ISEmMu57WbWGD1t93qNn+iWnygjd+PpJaHItQmVBrDke8LPqnIcBes/grMdeon7+VHko94qUWkhOkTFiw8uUETtsGL7PqUi/58GdUmVgmN5HnXUj5mIdU466uNPQLzmpxrD1JYOHWt9iSKpDYasG5p1yYuVZF3sVeOGRR3PtmVft0u+6tYd+5qg3YOja57eGbPuIQXu/Y8UZJyvR88Zslw9zTjrUnT769es0OLq4m+AISapGSIq90VBPH/06jAxa8zQ2ZHMZBiTXNhrq6fP5Cxq4uqiV8Kp/wkf0S65pEOqop88njAyIejyl/4YS9E6qbhDqqPf7T0v6rXiY1zu2DMF7qvzCu+jyqf9rWN/l93sJ3h67K+EP3qlrMIz0WVaYGRzzCkG7vvnAPe/UNSqs19LbQYIZmPgVv8M9740OI8GRBVmB1jfomvhFw5l73psU1nPJzbFBUQ/RZadNw5n7JocFLcpvJrzsvKUCneRFZuXMfZPDSPeF12MCop+iY8JnsMps5f6fwgIXXA0MiCxA+4RPYOX8z2Gk2/wrLzrElYOV83+FBcy7vK/j2mdg/e+wrnNzxwqVgqUh7Q8B5YCq9660DQAAAABJRU5ErkJggg==";
            option.size = new AMap.Size(19, 31);
            option.imageSize = new AMap.Size(19, 31);
            x = -14;
            y = -34;
        } else if (type == "end_node") {
            option.image = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAfCAYAAAAFkva3AAAEIklEQVR42qWUW2ibdRjGI6J4Kd4IXrbNej6f2xybfDmnydpOwc276Z2g0F4IMrfplYgiihO2KwV3o65TZJa2ox7WgeDaiSJrt4rs0PSQpm3SL4cvyeP7/AOBkc2tW+HHm/d9n+f5/79+JCYAFSSHwy8IE8KccFvICqw/cc79vXx3NTvh0FPCu4KeCUdhhEdRCI+hGDrEqnrOuaeO+nuGJULBZ4VZPRRBISgBQQnwj6DgiQhhVvacqz11or8oPHdX2FbQ/6QwowdLQXn/QRQOHYbh8MKwa4r8yEuqz7sC3Csd9eKbF54uh20G/MeTgWHkA/IocoP88feAeBxG9EXkrG5V+We8OY6cTUOOh2glfUp89KuwdZ/veUHPyWmGN4qs3YPC0jKMYyeRe2MCWYsLhXPnUdR1zktcmqdODo6CPvqZY4p5veM7vhAM34ic6IfxwUcoLi4iO+BiAPtS/fwMZ+WDsgNu6pWPfsmZMN3xuC/uaRFkXVGkBzzKmP91vsTUDIo3byF36oyqxpdn1Tzd5yLUKx/9zDHdcrvX0u4oMo4QdApCY4ritWXovUNIv/KqqoWFq+qg7Nsn2RPqlY9+yYmZ/nU5CxnXQaStQez1DCkKEpR+fRy6hGZPnUaBt/r2PDISVIzH2XNOrfLRzxzTP05HUh+KQLcGkOoeQvaLr9QNiptx5KamkXn/Q+wdOQrjl3lkPjstGicrZ9QrH/2Ss2u6brct7NjD0AdDSHa5kPKNKZKdznIlqcMqkIeU59TTR7/kLJqWbNaP12w+6LYIUkdeQ/abSRhXrqpHyV9bQtI7WrqlBCVfPqr63Q6HItntVr4N8UvOJ6a/LYN9NywOpCwR7Pb6kflxGqm3TsjrHsV2u4Ooz5mvJ/n43Jd2HU7qlY9+5qhvwJ8D/XO3BzQk+4ex3elGosUh2CvY1kaQvTAtdYw6paeP/vLX6Y/+vlohk+iT5+8JINHmxFaz/b5wTx319NFfDiMLvT0nVnrkf9ETQqJVQ7zJjnijrQLOuaeOevoqfoJ+7+56RlhZ7dKw3RXAZpMDGw3WCjjnnjrq6asII791dUb/6hxEoj2IeLOG9Xob1uusZdhzzj111N/3l5Zc7mifWZHXvtUWkJs4sFZrKcOec+5FN0v9/4ZdamttEQpbrXxUTUKsiJktrKrnnHvqHhhGfm5tObvUbBOzH7FaB+5UD7KqnnPuqXuosLnmpgahuNHolxu5JcyqKnvOuX/oMDLb2Di53GDHeoMXq2anquw5535fYdMN9e7LDe3yFn2IHdBUZc/5vsOm6uueEG7cNLuxZvaBlT3n+w4jF2prjy2YexGr8YBV+nc4f6SwHw4cqJs1N2K12gNW9o8cRr4311xfqXKClf1jhX1XU/3pYlUvWB877Fx1lVvYEbQHaf8DXsIRTnndJhMAAAAASUVORK5CYII=";
            option.size = new AMap.Size(19, 31);
            option.imageSize = new AMap.Size(19, 31);
            x = -14;
            y = -34;
        } else {
            option.imageOffset = new AMap.Pixel(0, -38);
        }
        var icon = type == "bus" ? 'https://webapi.amap.com/images/car.png' : new AMap.Icon(option);
        var marker = new AMap.Marker({
            map: map,
            icon: icon,
            position: lnglat,
            //title: '测试',
            //extData: { item: e, index: l },
            offset: {
                x: x,
                y: y
            }
        })
        return marker;
    }

    var drawpoint = function (map, points, callback) {
        for (var i = 0; i < points.length; i++) {
            if (points[i].Gis == "") {
                continue
            }
            var option = {
                lnglat: points[i].Gis,
                type: points[i].Type
            }
            var marker = createmark(map, option);
            marker.setLabel({
                content: points[i].Name,
                offset: {
                    x: points[i].Name.length * -5 + 8,
                    y: -26
                }
            });
            AMap.event.addListener(marker, "click", function (e) {
                console.log(e.target);
                if (typeof callback == "function") {
                    callback(e.target);
                }
            })
        }
        setTimeout(function () {
            map.setFitView();
        }, 20)
    }

    var poyline = function (map, points) {
        var waypoints = [];
        var startPoint = newpoint(points[0].Gis);
        var endPoint = newpoint(points[points.length - 1].Gis);
        for (var i = 0; i < points.length; i++) {
            if (i != 0 && i != points.length - 1) {
                waypoints.push(newpoint(points[i].Gis));
            }
        }
        // 根据起终点经纬度规划驾车导航路线
        map.plugin(["AMap.Driving"], function () {
            var driving = new AMap.Driving({
                policy: AMap.DrivingPolicy.LEAST_DISTANCE,
                extensions: "all"
            });
            console.log(driving);
            if (waypoints.length > 0) {
                driving.search(startPoint, endPoint, {
                    waypoints: waypoints
                });
            } else {
                driving.search(startPoint, endPoint);
            }

            AMap.event.addListener(driving, "complete", function (result) {
                //console.log(result)
                var routes = result.routes;
                var path = [];
                if (routes.length) {
                    for (var i = 0; i < routes[0].steps.length; i++) {
                        for (var j = 0; j < routes[0].steps[i].path.length; j++) {
                            path.push(routes[0].steps[i].path[j]);
                        }
                    }
                }
                var polyline = new AMap.Polyline({
                    map: map,
                    path: path,
                    strokeColor: "#00b5fe",
                    strokeOpacity: 0.8,
                    strokeWeight: 4,
                    strokeDasharray: [10, 5],
                    isOutline: !0,
                    outlineColor: "#2770ce"
                });
                setTimeout(function () {
                    map.setFitView();
                }, 20)
            });
        });
    }

    var clearMark = function (map) {
        map.clearMap();
    }
    var getAddress = function (position) {
        AMap.plugin('AMap.Geocoder', function () {
            var geocoder = new AMap.Geocoder({})

            var lnglat = [position.coords.longitude, position.coords.latitude]

            geocoder.getAddress(lnglat, function (status, result) {
                if (status === 'complete' && result.info === 'OK') {
                    // result为对应的地理位置详细信息
                    console.log(result)
                }
            })
        })
    }
    return {
        init: function (container) {
            return init(container)
        },
        newpoint: function (LngLat) {
            return newpoint(LngLat)
        },
        drawpoint: function (map, points, callback) {
            return drawpoint(map, points, callback)
        },
        poyline: function (map, points) {
            return poyline(map, points)
        },
        createmark: function (map, pointinfo) {
            return createmark(map, pointinfo)
        },
        clearMark: function (map) {
            return clearMark(map)
        },
        convertFrom: function (gps, type, map, VehicleNo) {
            return convertFrom(gps, type, map, VehicleNo)
        },
        getAddress: function (position) {
            return getAddress(position)
        },
        driving: function (map, startLngLat, endLngLat, callback) {
            return driving(map, startLngLat, endLngLat, callback)
        }
    }

}();
export default mapUtil